import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import ListPage from "../../../layouts/page/ListPage";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import EmployeeSelect from "../../../components/Custom/Main/Employee/EmployeeSelect";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { SearchOperation } from "../../../../utils/ApiUtils";

const PotBonusRuleList = () => {

    const { t } = useTranslation();
    const [employeeFilter, setEmployeeFilter] = useState(null);
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const activeFilters = [];

        if (employeeFilter) {
            activeFilters.push({
                field: "employee.id",
                value: employeeFilter.value,
                operation: SearchOperation.EQUAL
            });
        }

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setEmployeeFilter(null);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("pot_bonus_rules")} motherMenu={t("gamification.pot")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                {/* g-2 e as colunas md garantem que o filtro empilhe no celular em vez de
                    espremer o select. */}
                <Row className="g-2 align-items-end">
                    <Col lg={4} md={6}>
                        <FormLabel>{t('employee')}</FormLabel>
                        <EmployeeSelect
                            value={employeeFilter}
                            onChange={setEmployeeFilter}
                        />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t("pot_bonus_rules")}
                motherMenu={t("gamification.pot")}
                path={Api.gamification.pot_bonus_rule}
                route={MenuConfig.gamification.pot_bonus_rule.route}
                columns={Columns}
                filters={filters}
            />
        </>
    );
}

export default PotBonusRuleList;
